import React from 'react';
import { PageTemplate } from '@/components/molecules/PageTemplate';

export const QueryBuilder: React.FC = () => {
  return (
    <PageTemplate
      title="SOQL Query Builder"
      description="Build and execute SOQL queries"
    />
  );
};